import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Yarr Mouth Inc</h1>
    </div>
  );
}

export default App;
